import React, {memo, useCallback} from "react";
import PropTypes from "prop-types";
import {Button} from "@mui/material";
import NotInterestedOutlinedIcon from "@mui/icons-material/NotInterestedOutlined";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import {useRegulationsStyles} from "./styles/Styles";

const filteredSx = {opacity: 0.6};

const UserFilterButton = memo(({regulation, isFiltered, setCurrentFilters}) => {
  const {classes} = useRegulationsStyles();
  const title = isFiltered ? "Include" : "Exclude";
  const filterType = isFiltered ? "userInclude" : "userExclude";

  const handleClick = useCallback(
      (event) => {
        event.stopPropagation();
        setCurrentFilters((prev) => ({
          ...prev,
          [filterType]: [...prev[filterType], regulation],
        }));
      },
      [regulation, filterType, setCurrentFilters],
  );

  return (
    <Button
      color={isFiltered ? "success" : "neutral"}
      size="small"
      variant="outlined"
      onClick={handleClick}
      startIcon={isFiltered ? <AddOutlinedIcon /> : <NotInterestedOutlinedIcon />}
      className={classes.userFilterButton}
      disableRipple
      sx={isFiltered ? filteredSx : undefined}
    >
      <span>{title}</span>
    </Button>
  );
});

UserFilterButton.propTypes = {
  regulation: PropTypes.object.isRequired,
  isFiltered: PropTypes.bool,
  setCurrentFilters: PropTypes.func.isRequired,
};

export default UserFilterButton;
